import { useState } from "react"
import * as React from "react"
import PropTypes from "prop-types"
import { Button, Dialog, DialogTitle, IconButton, Menu, MenuItem, ListSubheader } from "@mui/material"
import { Close, Add } from "@mui/icons-material"

import BasketRulesPanel from "../basket-rules-panel"
import SmartTradeRulesPanel from "../smart-trade-rules-panel"
import SmartTradeRuleSearch from "modules/smart-trade-rule-search"
import "./styles.scss"

export default function Rules(props) {
  const [dialog, setDialog] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const open = Boolean(anchorEl)

  const onApply = () => {
    const { onApplyRules } = props
    onApplyRules()
  }

  const onChange = (name, value) => {
    const { setActiveBasketRule } = props

    setActiveBasketRule(name, value)
  }

  const onRemove = (item) => {
    const { removeSmartTradeRule } = props
    removeSmartTradeRule(item)
  }

  const toggleMenu = (e) => setAnchorEl(e.currentTarget)
  const closeMenu = () => setAnchorEl(null)
  const makeMenuAction = (action) => () => {
    closeMenu()
    setDialog(action)
  }

  const closeDialog = () => {
    setDialog(null)
  }

  const {
    hasError,
    basketRules,
    applyButtonEnabled,
    resetRules,
    isReadOnly,
    smartTradeRulesSearchResults,
    smartTradeRulesSearch,
    smartTradeRulesSearchValue,
    setSmartTradeRule,
    smartTradeRules,
    selectedDate,
    currentSmartTradeValues,
    smartLabel,
  } = props

  return <>
    <div className="components_smart-trade-panel-rules">
      {hasError && <div className="error-text">{`An error occured while performing the smart ${smartLabel}, please change the rules and try again.`}</div>}
      <h2>Basket</h2>
      <BasketRulesPanel onChange={onChange} rules={basketRules} isReadOnly={isReadOnly} />
      <h2>
        Smart&nbsp;
        {smartLabel}
        <span>
          {!isReadOnly && <IconButton id="smart-trade-add-rule" onClick={toggleMenu} size="medium" color="primary"><Add /></IconButton>}
          <Menu
            id="smart-trade-rules-add-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={closeMenu}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <ListSubheader component="div" id="nested-list-subheader">
              {`Add smart ${smartLabel} rules`}
            </ListSubheader>
            <MenuItem onClick={makeMenuAction("exposure")}>Exposure</MenuItem>
            <MenuItem onClick={makeMenuAction("composition")}>Composition</MenuItem>
          </Menu>
        </span>
      </h2>
      <SmartTradeRulesPanel
        isReadOnly={isReadOnly}
        smartTradeRulesSearchResults={smartTradeRulesSearchResults}
        smartTradeRulesSearch={smartTradeRulesSearch}
        smartTradeRulesSearchValue={smartTradeRulesSearchValue}
        setSmartTradeRule={setSmartTradeRule}
        smartTradeRules={smartTradeRules}
        currentSmartTradeValues={currentSmartTradeValues}
        removeSmartTradeRule={onRemove}
        selectedDate={selectedDate}
        smartLabel={smartLabel}
      />
      {!isReadOnly && <div className="buttons-bar">
        <Button variant="contained" color="primary" onClick={onApply} disabled={!applyButtonEnabled}>Apply</Button>
        <Button variant="outlined" className="reset-button" onClick={resetRules}>Reset rules</Button>
      </div>}
    </div>
    <Dialog className="smart-trade-rule-search" open={!!dialog} onClose={closeDialog}>
      <DialogTitle>
        Search&nbsp;
        {dialog}
        &nbsp;rules
        <IconButton aria-label="close" onClick={closeDialog} size="large">
          <Close />
        </IconButton>
      </DialogTitle>

      <SmartTradeRuleSearch
        setSmartTradeRule={setSmartTradeRule}
        selectedDate={selectedDate}
        ruleType={dialog}
        smartLabel={smartLabel}
        existingRules={smartTradeRules}
      />
    </Dialog>
  </>
}

Rules.propTypes = {
  hasError: PropTypes.bool.isRequired,
  onApplyRules: PropTypes.func.isRequired,
  setActiveBasketRule: PropTypes.func.isRequired,
  basketRules: PropTypes.array.isRequired,
  applyButtonEnabled: PropTypes.bool.isRequired,
  resetRules: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  smartTradeRulesSearchResults: PropTypes.array,
  smartTradeRulesSearch: PropTypes.func.isRequired,
  smartTradeRulesSearchValue: PropTypes.string,
  setSmartTradeRule: PropTypes.func.isRequired,
  smartTradeRules: PropTypes.array,
  removeSmartTradeRule: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  currentSmartTradeValues: PropTypes.object,
  smartLabel: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
}
